import { type MessageDescriptor, defineMessages } from 'react-intl';

type TourMessageKey =
	| 'arrowsHeading'
	| 'arrowsImageAlt'
	| 'arrowsModalBody'
	| 'arrowsPanelBody'
	| 'back'
	| 'dismiss'
	| 'done'
	| 'introBody'
	| 'introHeading'
	| 'next'
	| 'resizeBody'
	| 'resizeHeading'
	| 'stepCount';

export const tourMessages: Record<TourMessageKey, MessageDescriptor> = defineMessages({
	arrowsHeading: {
		id: 'jira-nin-issue-preview-panel.tour.arrows-heading',
		defaultMessage: 'Preview your work items',
		description:
			'Heading for the tour step pointing at the work item navigation arrows. Shared by the preview panel and modal variants',
	},
	arrowsImageAlt: {
		id: 'jira-nin-issue-preview-panel.tour.arrows-image-alt',
		defaultMessage: 'Navigation arrows on the glance panel',
		description:
			'Alt text for the illustration on the navigation arrows tour step, shared by both variants',
	},
	arrowsModalBody: {
		id: 'jira-nin-issue-preview-panel.tour.arrows-modal-body',
		defaultMessage:
			'Select the arrows to move through work items. Select minimise to view your work in a preview panel.',
		description:
			'Body for the navigation arrows tour step when the work item opened in the modal view',
	},
	arrowsPanelBody: {
		id: 'jira-nin-issue-preview-panel.tour.arrows-panel-body',
		defaultMessage: 'Select the arrows to move through work items. Select expand for modal view.',
		description:
			'Body for the navigation arrows tour step when the work item opened in the preview panel',
	},
	back: {
		id: 'jira-nin-issue-preview-panel.tour.back',
		defaultMessage: 'Back',
		description: 'Button returning to the previous step of the preview panel changeboarding tour',
	},
	dismiss: {
		id: 'jira-nin-issue-preview-panel.tour.dismiss',
		defaultMessage: 'Dismiss',
		description:
			'Aria label for the dismiss (X) control on the preview panel changeboarding tour cards',
	},
	done: {
		id: 'jira-nin-issue-preview-panel.tour.done',
		defaultMessage: 'Done',
		description:
			'Button closing the preview panel changeboarding tour from its final step, where there is nothing further to advance to',
	},
	introBody: {
		id: 'jira-nin-issue-preview-panel.tour.intro-body',
		defaultMessage: 'View work item details in a layout that works best for your list.',
		description: 'Body for the opening step of the preview panel changeboarding tour',
	},
	introHeading: {
		id: 'jira-nin-issue-preview-panel.tour.intro-heading',
		defaultMessage: 'New ways to view work in context',
		description: 'Heading for the opening step of the preview panel changeboarding tour',
	},
	next: {
		id: 'jira-nin-issue-preview-panel.tour.next',
		defaultMessage: 'Next',
		description: 'Button advancing to the next step of the preview panel changeboarding tour',
	},
	resizeBody: {
		id: 'jira-nin-issue-preview-panel.tour.resize-body',
		defaultMessage: 'Drag to resize the panel and view more work item information.',
		description: 'Body for the tour step pointing at the preview panel’s resize handle',
	},
	resizeHeading: {
		id: 'jira-nin-issue-preview-panel.tour.resize-heading',
		defaultMessage: 'Expand the panel',
		description: 'Heading for the tour step pointing at the preview panel’s resize handle',
	},
	/**
	 * One ICU message rather than five discrete strings ("1 of 2" … "3 of 3"). The step total varies
	 * with which surface the user has open, so a single message covers every sequence and any added
	 * later. `icuFormat` is enabled in the team's traduki descriptor.
	 */
	stepCount: {
		id: 'jira-nin-issue-preview-panel.tour.step-count',
		defaultMessage: '{current} of {total}',
		description:
			'Progress counter on the preview panel changeboarding tour, e.g. “2 of 3”. The total varies by which surface the user has open, so both numbers are supplied at runtime',
	},
});
